module.exports = __webpack_public_path__ + "img/card-locked.b9e56796.svg";